const sizes: { [key: string]: string } = {
    xs: 'border-[1.5px] w-[12px] h-[12px]',
    sm: 'border-[2px] w-[16px] h-[16px]',
    lg: 'border-[4px] w-[36px] h-[36px]',
};

export type SpinnerProps = {
    size?: 'xs' | 'sm' | 'lg';
};

function Spinner({ size = 'lg' }: SpinnerProps): JSX.Element {
    return (
        <div
            className={`border-gray-200 border-t-gray-600 rounded-full duration-500 animate-[spin_0.65s_linear_infinite] ${sizes[size]}`}
        ></div>
    );
}

export default Spinner;
